import React, { useContext } from "react"
import { PCViewContext } from "./Common/PCViewContext"
import Header from "./Common/Header"
import Breadcrumb from "./Common/Breadcrumb"
import Footer from "./Common/Footer"
import Container from "./PlaceImages/Container"
import { Place } from "./types/place"

const PlaceImages = (props) => {
  const place: Place = JSON.parse(props.place)
  const isPC = useContext(PCViewContext)

  return (
    <React.Fragment>
      <Header />
      {isPC && (
        <React.Fragment>
          <Breadcrumb {...props} place={place} />
          <Container {...props} place={place} />
        </React.Fragment>
      )}
      {!isPC && (
        <React.Fragment>
          <Container {...props} place={place} />
          <Breadcrumb {...props} place={place} />
        </React.Fragment>
      )}
      <Footer {...props} />
    </React.Fragment>
  )
}
export default PlaceImages
